import React from 'react';
import { motion } from 'framer-motion';

// The animated "voice being" orb — layered warm gradients, breathing when active.
export default function VoiceOrb({ size = 220, active = false, from = '#F2A154', to = '#E06E53' }) {
  return (
    <div className="relative flex items-center justify-center" style={{ width: size, height: size }} data-testid="voice-orb">
      {/* halo */}
      <motion.div
        className="absolute rounded-full"
        style={{ inset: -size * 0.12, background: `radial-gradient(50% 50% at 50% 50%, ${to}33 0%, transparent 70%)` }}
        animate={active ? { scale: [1, 1.18, 1], opacity: [0.7, 1, 0.7] } : { scale: [1, 1.06, 1] }}
        transition={{ duration: active ? 1.6 : 4, repeat: Infinity, ease: 'easeInOut' }}
      />
      {/* slow-rotating gradient body */}
      <motion.div
        className="absolute inset-0 rounded-full"
        style={{ background: `conic-gradient(from 0deg, ${from}, ${to}, #FDE08B, ${from})`, filter: 'blur(2px)' }}
        animate={{ rotate: 360 }}
        transition={{ duration: 14, repeat: Infinity, ease: 'linear' }}
      />
      {/* core */}
      <motion.div
        className="absolute rounded-full"
        style={{ inset: size * 0.06, background: `radial-gradient(120% 120% at 32% 24%, ${from} 0%, ${to} 80%)` }}
        animate={active ? { scale: [1, 1.08, 1] } : { scale: [1, 1.02, 1] }}
        transition={{ duration: active ? 1.2 : 3.4, repeat: Infinity, ease: 'easeInOut' }}
      />
      {/* clay highlight */}
      <div className="absolute rounded-full pointer-events-none"
        style={{ inset: size * 0.12, background: 'radial-gradient(100% 100% at 35% 22%, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0) 55%)' }} />
    </div>
  );
}
